export default __webpack_public_path__ + "static/media/SuggestedLogo_Green.22114806.svg";